const PANEL_DOMAIN = "https://panel.retaillemon.com";

export function isLovableManagedHost(host: string): boolean {
  return (
    host === "panel.retaillemon.com" ||
    host.endsWith(".lovable.app") ||
    host.endsWith(".lovableproject.com") ||
    host.endsWith(".lovable.dev") ||
    host === "localhost" ||
    host === "127.0.0.1"
  );
}

export function getPanelUrl(path: string = "/dashboard"): string {
  const host = window.location.hostname;
  return isLovableManagedHost(host) ? path : `${PANEL_DOMAIN}${path}`;
}

/**
 * Hosts donde el Client ID propio de Google tiene orígenes autorizados.
 * En cualquier otro host (previews de Lovable, sandbox local) el botón GIS
 * falla con ERR_BLOCKED_BY_RESPONSE, así que allí usamos el OAuth gestionado.
 */
export function isProductionAuthHost(): boolean {
  if (typeof window === "undefined") return true;
  const host = window.location.hostname;
  return (
    host === "panel.retaillemon.com" ||
    host === "retaillemon.com" ||
    host === "www.retaillemon.com"
  );
}
